import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  SwipeableDrawer,
  IconButton,
  Grid,
  List,
  ListItemText,
  ListItem,
  Collapse,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import Logo from "./logo";
import CloseIcon from "@material-ui/icons/Close";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { Link } from "gatsby";

const useStyles = makeStyles({
  menuIcon: {
    fontSize: 24,
  },
  container: {
    width: "80vw",
    maxWidth: 350,
    background: "rgb(250,250,250)",
    height: "100%",
    overflow: "hidden",
  },
  header: {
    background: "rgb(255,255,255)",
    height: 60,
    padding: "10px 20px",
  },
  listItem: {
    background: "rgb(255,255,255)",
    border: "1px solid rgb(240,240,240)",
    borderRight: "0px",
    borderLeft: "0px",
    borderTop: "0px",
  },
  listItemSub: {
    background: "rgb(255,255,255)",
    paddingLeft: "10%",
    border: "1px solid rgb(240,240,240)",
    borderRight: "0px",
    borderLeft: "0px",
    borderTop: "0px",
  },
  listContainer: {
    width: "100%",
  },
  navContainer: {
    height: "100%",
  },
});

const HeaderDrawer = (props) => {
  const classes = useStyles();
  const [state, setState] = useState({
    left: false,
  });
  const [open, setOpen] = useState(false);
  const [whereWeGo, setWhereWeGo] = useState(false);

  const toggleDrawer = (side, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  const handleClick = () => {
    setOpen(!open);
  };
  const handleWhereWeGo = () => {
    setWhereWeGo(!whereWeGo);
  };

  const activeStyle = {
    color: "#ff1744",
  };

  return (
    <div style={{ display: "inline-block" }}>
      <IconButton onClick={toggleDrawer("left", true)}>
        <MenuIcon
          className={classes.menuIcon}
          style={{ color: props.color, transition: "color 0.5s ease" }}
        />
      </IconButton>
      <SwipeableDrawer
        open={state.left}
        onClose={toggleDrawer("left", false)}
        onOpen={toggleDrawer("left", true)}
      >
        <Grid container className={classes.container} alignItems="flex-start">
          <Grid
            item
            xs={12}
            container
            alignItems="center"
            justify="flex-start"
            className={classes.header}
          >
            <CloseIcon
              style={{ marginRight: 20 }}
              onClick={toggleDrawer("left", false)}
            />
            <Logo></Logo>
          </Grid>
          <Grid item xs={12} container className={classes.navContainer}>
            <List component="nav" className={classes.listContainer}>
              <Link color="inherit" activeStyle={activeStyle} to="/calendar">
                <ListItem className={classes.listItem}>
                  <ListItemText primary="Calendar" />
                  <ArrowForwardIosIcon
                    style={{ fontSize: ".95rem", marginRight: 2 }}
                  />
                </ListItem>
              </Link>
              <Link
                color="inherit"
                activeStyle={activeStyle}
                to="/fitness-hikes"
              >
                <ListItem className={classes.listItem}>
                  <ListItemText primary="Fitness Hikes" />
                  <ArrowForwardIosIcon
                    style={{ fontSize: ".95rem", marginRight: 2 }}
                  />
                </ListItem>
              </Link>
              <ListItem onClick={handleClick} className={classes.listItem}>
                <ListItemText primary="About TSA" />
                {open ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <Link
                    color="inherit"
                    activeStyle={activeStyle}
                    to="/about-us"
                  >
                    <ListItem button className={classes.listItemSub}>
                      <ListItemText primary="About us" />
                    </ListItem>
                  </Link>
                  <Link
                    color="inherit"
                    activeStyle={activeStyle}
                    to="/why-choose-tsa"
                  >
                    <ListItem button className={classes.listItemSub}>
                      <ListItemText primary="Why choose TSA" />
                    </ListItem>
                  </Link>
                  <Link
                    color="inherit"
                    activeStyle={activeStyle}
                    to="/our-story"
                  >
                    <ListItem button className={classes.listItemSub}>
                      <ListItemText primary="Our Story" />
                    </ListItem>
                  </Link>
                  <Link
                    color="inherit"
                    activeStyle={activeStyle}
                    to="/our-team"
                  >
                    <ListItem button className={classes.listItemSub}>
                      <ListItemText primary="Meet our team" />
                    </ListItem>
                  </Link>
                </List>
              </Collapse>
              <ListItem className={classes.listItem} onClick={handleWhereWeGo}>
                <ListItemText primary="Where we go" />
                {whereWeGo ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={whereWeGo} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <Link
                    color="inherit"
                    activeStyle={activeStyle}
                    to="/australia"
                  >
                    <ListItem button className={classes.listItemSub}>
                      <ListItemText primary="Australia" />
                    </ListItem>
                  </Link>
                  <Link
                    color="inherit"
                    activeStyle={activeStyle}
                    to="/new-zealand"
                  >
                    <ListItem button className={classes.listItemSub}>
                      <ListItemText primary="New Zealand" />
                    </ListItem>
                  </Link>
                  <Link color="inherit" activeStyle={activeStyle} to="/japan">
                    <ListItem button className={classes.listItemSub}>
                      <ListItemText primary="Japan" />
                    </ListItem>
                  </Link>
                  <Link
                    color="inherit"
                    activeStyle={activeStyle}
                    to="/cambodia"
                  >
                    <ListItem button className={classes.listItemSub}>
                      <ListItemText primary="Cambodia" />
                    </ListItem>
                  </Link>
                  <Link color="inherit" activeStyle={activeStyle} to="/morocco">
                    <ListItem button className={classes.listItemSub}>
                      <ListItemText primary="Morocco" />
                    </ListItem>
                  </Link>
                  <Link color="inherit" activeStyle={activeStyle} to="/myanmar">
                    <ListItem button className={classes.listItemSub}>
                      <ListItemText primary="Myanmar" />
                    </ListItem>
                  </Link>
                  <Link color="inherit" activeStyle={activeStyle} to="/iceland">
                    <ListItem button className={classes.listItemSub}>
                      <ListItemText primary="Iceland" />
                    </ListItem>
                  </Link>
                  <Link
                    color="inherit"
                    activeStyle={activeStyle}
                    to="/tanzania"
                  >
                    <ListItem button className={classes.listItemSub}>
                      <ListItemText primary="Tanzania" />
                    </ListItem>
                  </Link>
                  <Link
                    color="inherit"
                    activeStyle={activeStyle}
                    to="/patagonia"
                  >
                    <ListItem button className={classes.listItemSub}>
                      <ListItemText primary="Patagonia" />
                    </ListItem>
                  </Link>
                </List>
              </Collapse>
              {/* <ListItem className={classes.listItem}>
                <ListItemText primary="Our Adventures" />
                <ArrowForwardIosIcon
                  style={{ fontSize: ".95rem", marginRight: 2 }}
                />
              </ListItem>
              <ListItem className={classes.listItem}>
                <ListItemText primary="New's & Stories" />
                <ArrowForwardIosIcon
                  style={{ fontSize: ".95rem", marginRight: 2 }}
                />
              </ListItem> */}
              <a
                activeStyle={activeStyle}
                href="https://shop.takeshapeadventures.com.au"
              >
                <ListItem className={classes.listItem}>
                  <ListItemText primary="Our Shop" />
                  <ArrowForwardIosIcon
                    style={{ fontSize: ".95rem", marginRight: 2 }}
                  />
                </ListItem>
              </a>
              <Link color="inherit" activeStyle={activeStyle} to="/contact-us">
                <ListItem className={classes.listItem}>
                  <ListItemText primary="Contact" />
                  <ArrowForwardIosIcon
                    style={{ fontSize: ".95rem", marginRight: 2 }}
                  />
                </ListItem>
              </Link>
            </List>
          </Grid>
        </Grid>
      </SwipeableDrawer>
    </div>
  );
};
export default HeaderDrawer;
